import Vue from 'vue';
import productFlowTransformer from './../../transformers/productFlow';

const success = (resolve, response) => {
  resolve(response);
};

const failed = (errors, reject) => {
  if (errors.error) {
    reject(errors.error);
    return;
  }

  reject(productFlowTransformer.fetch(errors));
};

export default productFlow => (
  new Promise((resolve, reject) => {
    Vue.$http
      .post('/productflow', productFlow)
      .then((response) => {
        success(resolve, response);
      })
      .catch((error) => {
        failed(error.response.data, reject);
      });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/productFlow/store.js